export default __webpack_public_path__ + "static/media/translator-ss1.1bb59523.png";